import { styled } from '@material-ui/core/styles'
import {
  AccountCircleOutlined
} from '@material-ui/icons'

export const ProfileIcon = styled(AccountCircleOutlined)({
  color: '#6C757D'
})
